module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e389e587fca11d3a2930383e2440078e.png";